/** تبدیل مبلغ عددی به معادل حروفی فارسی (ریال صحیح) */

const ones = ['', 'یک', 'دو', 'سه', 'چهار', 'پنج', 'شش', 'هفت', 'هشت', 'نه'];
const tensNames = ['', 'ده', 'بیست', 'سی', 'چهل', 'پنجاه', 'شصت', 'هفتاد', 'نود'];
const hundredsNames = ['', 'یکصد', 'دویست', 'سیصد', 'چهارصد', 'پانصد', 'ششصد', 'هفتصد', 'هشتصد', 'نهصد'];
const teens = ['ده', 'یازده', 'دوازده', 'سیزده', 'چهارده', 'پانزده', 'شانزده', 'هفده', 'هجده', 'نوزده'];

function twoDigitsToWords(n: number): string {
  if (n <= 0) return '';
  if (n < 10) return ones[n] ?? '';
  if (n < 20) return teens[n - 10] ?? '';
  const t = Math.floor(n / 10);
  const o = n % 10;
  const ten = tensNames[t] ?? '';
  if (!o) return ten;
  return `${ten} و ${ones[o]}`;
}

function threeDigitsToWords(n: number): string {
  if (n <= 0) return '';
  if (n < 100) return twoDigitsToWords(n);
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const hp = hundredsNames[h] ?? '';
  if (!rest) return hp;
  return `${hp} و ${twoDigitsToWords(rest)}`;
}

/** عدد صحیح مثبت تا حدود میلیاردها؛ برای ۰ خروجی «صفر» */
export function amountToPersianWords(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '';
  let num = Math.floor(n);
  if (num === 0) return 'صفر';

  const parts: string[] = [];
  const billions = Math.floor(num / 1_000_000_000);
  num %= 1_000_000_000;
  const millions = Math.floor(num / 1_000_000);
  num %= 1_000_000;
  const thousands = Math.floor(num / 1000);
  num %= 1000;
  const remainder = num;

  if (billions) {
    parts.push(billions === 1 ? 'یک میلیارد' : `${threeDigitsToWords(billions)} میلیارد`);
  }
  if (millions) {
    parts.push(millions === 1 ? 'یک میلیون' : `${threeDigitsToWords(millions)} میلیون`);
  }
  if (thousands) {
    parts.push(thousands === 1 ? 'هزار' : `${threeDigitsToWords(thousands)} هزار`);
  }
  if (remainder) {
    parts.push(threeDigitsToWords(remainder));
  }
  return parts.join(' و ');
}

/** معادل حروفی مبلغ به ریال (برای چک و بایگانی) */
export function amountToPersianWordsRial(n: number): string {
  const w = amountToPersianWords(n);
  if (!w) return '';
  return `${w} ریال`;
}

/** معادل حروفی مبلغ به تومان (ریال ÷ ۱۰) */
export function amountToPersianWordsToman(rial: number): string {
  if (!Number.isFinite(rial) || rial < 0) return '';
  const toman = Math.floor(rial / 10);
  const w = amountToPersianWords(toman);
  if (!w) return '';
  return `${w} تومان`;
}
